<div class="breadcrumb">
  <div class="container">
    <a routerLink="/">{{ 'Home' | translate }}</a> > {{ 'Relatório Interação Usuário' | translate }}
  </div>
</div>

<main class="container">
  <div class="consolidado-header">
    <h2>{{ 'Relatório Interação Usuário' | translate }}</h2>

    <div class="consolidado-filtros">
      <div class="filtro">
        <label for="cboIntervPais">{{ 'País' | translate }}</label>
        <select id="cboIntervPais" [(ngModel)]="filtro.countryCode">
          <option value="">{{ 'Selecione' | translate }}</option>
          <option *ngFor="let p of listPaises; trackBy: trackByCountryCode" [value]="p.countryCode">{{ p.name }}</option>
        </select>
      </div>

      <div class="filtro">
        <label for="cboIntervAno">{{ 'Ano' | translate }}</label>
        <select id="cboIntervAno" [(ngModel)]="filtro.ano">
          <option value="">{{ 'Selecione' | translate }}</option>
          <option *ngFor="let a of listAnos; trackBy: trackByIndex" [value]="a">{{ a }}</option>
        </select>
      </div>

      <div class="filtro">
        <label for="cboIntervMes">{{ 'Mês' | translate }}</label>
        <select id="cboIntervMes" [(ngModel)]="filtro.mes">
          <option value="">{{ 'Selecione' | translate }}</option>
          <option *ngFor="let m of listMeses; trackBy: trackByIndex" [value]="m.value">{{ m.label | translate }}</option>
        </select>
      </div>

      <div class="filtro" *ngIf="listaUsuarios.length > 0">
        <label for="cboIntervUsuario">{{ 'Usuário' | translate }}</label>
        <select id="cboIntervUsuario" [(ngModel)]="filtro.usuario" (ngModelChange)="filtrar()">
          <option value="">{{ 'Todos' | translate }}</option>
          <option *ngFor="let u of listaUsuarios; trackBy: trackByIndex" [value]="u">{{ u }}</option>
        </select>
      </div>

      <button class="btn-atualizar" (click)="atualizarDados()"
        [disabled]="!filtro.countryCode || !filtro.ano || !filtro.mes || isCarregando || isLoading">
        <span *ngIf="!isCarregando">{{ 'Atualizar Dados' | translate }}</span>
        <span *ngIf="isCarregando">{{ 'Atualizando...' | translate }}</span>
      </button>

      <button class="btn-buscar" (click)="buscar()"
        [disabled]="!filtro.countryCode || !filtro.ano || !filtro.mes || isLoading || isCarregando">
        <span *ngIf="!isLoading">{{ 'Consultar' | translate }}</span>
        <span *ngIf="isLoading">{{ 'Carregando...' | translate }}</span>
      </button>

      <button class="btn-limpar" (click)="limpar()" [disabled]="isLoading || isCarregando">
        {{ 'Limpar' | translate }}
      </button>

      <button class="btn-exportar" (click)="exportarCsv()"
        *ngIf="dadosFiltrados.length > 0" [disabled]="isLoading || isCarregando">
        {{ '↓ Exportar CSV' | translate }}
      </button>
    </div>
  </div>

  <div class="consolidado-table-wrap">
    <table class="consolidado-table mat-elevation-z2">

      <thead>
        <tr class="col-header-row">
          <th>{{ 'País' | translate }}</th>
          <th>{{ 'Período' | translate }}</th>
          <th>{{ 'Usuário' | translate }}</th>
          <th>{{ 'Interação' | translate }}</th>
          <th>{{ 'Instituição' | translate }}</th>
          <th>{{ 'Médico' | translate }}</th>
          <th>{{ 'Produto' | translate }}</th>
          <th>{{ 'Total General' | translate }}</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngIf="isLoading || isCarregando" class="row-empty">
          <td colspan="8" class="empty-msg loading-msg">{{ 'Carregando...' | translate }}</td>
        </tr>
        <tr *ngIf="!isLoading && !isCarregando && dadosFiltrados.length === 0" class="row-empty">
          <td colspan="8" class="empty-msg">
            <span *ngIf="semDados">{{ 'Nenhum dado encontrado' | translate }}</span>
            <span *ngIf="!semDados">{{ 'Selecione o País, o Ano e o Mês e clique em Consultar.' | translate }}</span>
          </td>
        </tr>
        <tr *ngFor="let row of dadosFiltrados; let i = index; trackBy: trackByRow"
            [class.row-alt]="i % 2 !== 0" [hidden]="isLoading || isCarregando">
          <td>{{ row.pais }}</td>
          <td>{{ row.periodo }}</td>
          <td>{{ row.usuario }}</td>
          <td>{{ row.interacaoUsuario | translate }}</td>
          <td class="num">{{ row.instituicao | number }}</td>
          <td class="num">{{ row.medico | number }}</td>
          <td class="num">{{ row.produto | number }}</td>
          <td class="num">{{ row.totalGeneral | number }}</td>
        </tr>
      </tbody>

      <tfoot *ngIf="dadosFiltrados.length > 0 && !isLoading && !isCarregando">
        <tr class="total-row">
          <td colspan="4">{{ 'Total' | translate }}</td>
          <td class="num">{{ totais.instituicao | number }}</td>
          <td class="num">{{ totais.medico | number }}</td>
          <td class="num">{{ totais.produto | number }}</td>
          <td class="num">{{ totais.totalGeneral | number }}</td>
        </tr>
      </tfoot>

    </table>
  </div>
</main>
